<div class="content mt-5">
      <div class="container-fluid">
        <div class="col-md-8 col-12 mr-auto ml-auto">
          <!--      Wizard container        -->
          <div class="wizard-container">
            <div class="card card-wizard active" data-color="rose" id="wizardProfile">
              <form action="#" method="" novalidate="novalidate">
                <div class="card-header text-center">
                  <h3 class="card-title">
                    Build Your Profile
                  </h3>
                  <h5 class="card-description">This information will let us know more about you.</h5>
                </div>
                <div class="wizard-navigation">
                  <ul class="nav nav-pills">
                    <li class="nav-item" style="width: 50%;">
                      <a class="nav-link active" href="#about" data-toggle="tab" role="tab">
                        About
                      </a>
                    </li>
                    <li class="nav-item" style="width: 50%;">
                      <a class="nav-link" href="#address" data-toggle="tab" role="tab">
                        Address
                      </a>
                    </li>
                  </ul>
                  <div class="moving-tab" style="width: 213.109px; transform: translate3d(-8px, 0px, 0px); transition: transform 0s ease 0s;">
                    About
                  </div></div>
                <div class="card-body">
                  <div class="tab-content">
                    <div class="tab-pane active" id="about">
                      <h5 class="info-text"> Let's start with the basic information (with validation)</h5>
                      <div class="row justify-content-center">
                        <div class="col-sm-4">
                          <div class="picture-container">
                            <div class="picture">
                              <img *ngIf="!data.picture" src="assets/dashboard/img/default-avatar.png" class="picture-src" id="wizardPicturePreview" title="">
                              <img *ngIf="data.picture" src="http://localhost:8000/{{data.picture}}" class="picture-src" id="wizardPicturePreview" title="">
                              <input type="file" id="wizard-picture" (change)="handleFileInput($event.target.files)">
                            </div>
                            <h6 class="description">Choose Picture</h6>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="input-group form-control-lg">
                            <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <i class="material-icons">face</i>
                                    </span>
                            </div>
                            <div class="form-group bmd-form-group">
                              <label for="exampleInput1" class="bmd-label-floating">First Name (required)</label>
                              <input type="text" class="form-control" id="exampleInput1" name="first_name" required="" aria-required="true" [(ngModel)]="data.first_name">
                            </div>
                          </div>
                          <div class="input-group form-control-lg">
                            <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <i class="material-icons">record_voice_over</i>
                                    </span>
                            </div>
                            <div class="form-group bmd-form-group">
                              <label for="exampleInput11" class="bmd-label-floating">Last Name (required)</label>
                              <input type="text" class="form-control" id="exampleInput11" name="last_name" required="" aria-required="true" [(ngModel)]="data.last_name">
                            </div>
                          </div>
                          <div class="input-group form-control-lg">
                            <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <i class="material-icons">date_range</i>
                                    </span>
                            </div>
                            <div class="form-group bmd-form-group">
                              <input type="date" class="form-control" id="exampleInput13" name="date_of_birth" required="" aria-required="true" [(ngModel)]="data.date_of_birth">
                            </div>
                          </div>
                          <div class="input-group form-control-lg">
                            <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <i class="material-icons">dialpad</i>
                                    </span>
                            </div>
                            <div class="form-group bmd-form-group">
                              <label for="exampleInput11" class="bmd-label-floating">Phone</label>
                              <input type="number" class="form-control" id="exampleInput12" name="phone" aria-required="false" [(ngModel)]="data.phone">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="account">
                      <h5 class="info-text"> What are you doing? (checkboxes) </h5>
                      <div class="row justify-content-center">
                        <div class="col-lg-10">
                          <div class="row">
                            <div class="col-sm-4">
                              <div class="choice" data-toggle="wizard-checkbox">
                                <input type="checkbox" name="jobb" value="Design">
                                <div class="icon">
                                  <i class="fa fa-pencil"></i>
                                </div>
                                <h6>Design</h6>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="choice" data-toggle="wizard-checkbox">
                                <input type="checkbox" name="jobb" value="Code">
                                <div class="icon">
                                  <i class="fa fa-terminal"></i>
                                </div>
                                <h6>Code</h6>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="choice" data-toggle="wizard-checkbox">
                                <input type="checkbox" name="jobb" value="Develop">
                                <div class="icon">
                                  <i class="fa fa-laptop"></i>
                                </div>
                                <h6>Develop</h6>
                              </div>
                              <div class="dropdown bootstrap-select"><select class="selectpicker" data-style="btn btn-primary btn-round" title="Single Select" data-size="7" tabindex="-98"><option class="bs-title-option" value=""></option>
                                <option disabled="" selected="">Choose city</option>
                                <option value="2">Foobar</option>
                                <option value="3">Is great</option>
                              </select><button type="button" class="dropdown-toggle btn btn-primary btn-round" data-toggle="dropdown" role="button" title="Choose city"><div class="filter-option"><div class="filter-option-inner"><div class="filter-option-inner-inner">Choose city</div></div> </div></button><div class="dropdown-menu " role="combobox"><div class="inner show" role="listbox" aria-expanded="false" tabindex="-1"><ul class="dropdown-menu inner show"></ul></div></div></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="address">
                      <div class="row justify-content-center">
                        <div class="col-sm-12">
                          <h5 class="info-text"> Are you living in a nice area? </h5>
                        </div>
                        <div class="col-sm-7">
                          <div class="form-group bmd-form-group">
                            <label class="bmd-label-static">Street Name</label>
                            <input type="text" class="form-control" name="street_name" [(ngModel)]="street_name">
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="form-group bmd-form-group">
                            <label class="bmd-label-static">Street No.</label>
                            <input type="text" class="form-control" name="street_number" [(ngModel)]="street_number">
                          </div>
                        </div>
                        <div class="mt-5">
                          <div class="form-group select-wizard">
                            <div class="dropdown bootstrap-select">
                              <select name="city" class="selectpicker" data-style="select-with-transition" title="Select City" [(ngModel)]="data.city" tabindex="-98">
                                <option *ngFor="let city of cities" value="{{city}}"> {{city}} </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="mr-auto">
                    <input type="button" class="btn btn-previous btn-fill btn-default btn-wd disabled" name="previous" value="Previous">
                  </div>
                  <div class="ml-auto">
                    <input type="button" class="btn btn-next btn-fill btn-rose btn-wd" name="next" value="Next">
                    <input type="button" class="btn btn-finish btn-fill btn-rose btn-wd" name="finish" value="Finish" style="display: none;" (click)="addAnnouncer()">
                  </div>
                  <div class="clearfix"></div>
                </div>
              </form>
            </div>
          </div>
          <!-- wizard container -->
        </div>
      </div>
    </div>

